import styled from 'styled-components';
import { vertical } from '../themes/scrollbars';

export const ScrollableListWrapper = styled.div`
  flex: 1;
  min-height: 0;
  margin: 0 -1.8rem 0;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1.6rem;
    background: linear-gradient(to bottom, transparent, ${({ theme }) => theme.colors.white});
    pointer-events: none;
    z-index: 1;
  }
`;

export const ScrollableList = styled.ol`
  ${vertical}
  display: flex;
  flex-direction: column;
  margin: 0 0 0 1.8rem;
  padding: 0 0.8rem 1rem 0;
  gap: 1rem;
  height: 100%;
  overflow-y: scroll;
`;
